import { render, staticRenderFns } from "./html.vue?vue&type=template&id=df713f24&scoped=true"
import script from "./html.vue?vue&type=script&lang=js"
export * from "./html.vue?vue&type=script&lang=js"
import style0 from "./html.vue?vue&type=style&index=0&id=df713f24&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df713f24",
  null
  
)

export default component.exports